import "./App.css";
import { ProjectProvider } from "./ProjectContext";
import { GrupoProvider } from "./GrupoContext";
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MenuSolicitante from "./componente_solicitante/menu_solicitante";
import SolicitarServicioGET from "./componente_solicitante/solicitar_servicio_get";
import IngresarSolicitud from "./componente_solicitante/ingresar_solicitud";
import AsignacionStaff from "./componente_lider/asignar_staff";
import CuartaPagina from "./componente_lider/actividades_asignadas";
import Sesion from "./seleccionador/sesion";
import PopupComponent from "./seleccionador/PopupComponent";
import EsperaDocumentos from "./componente_solicitante/espera_documento";
import MenuLider from "./componente_lider/menu_lider";
import ActividadesSinDocumentar from "./componente_lider/actividades_sin_documentar";
import Login from "./seleccionador/login";
import MenuStaff from "./componente_staff/menustaff";
import Rol from "./seleccionador/rol";
import Rol2 from "./seleccionador/rol2";
import Rol3 from "./seleccionador/rol3";
import SolicitudesAsignadas from "./componente_lider/actividades_asignadas";
import MisAsignaciones from "./componente_staff/misasignaciones";
import Cronometro from "./componente_staff/CronometroModal";
import AsignacionesEnRevision from "./componente_staff/asignacionesenrevision";
import RevisarActividadLider from "./componente_lider/revisaractividadlider";
import VerStaff from "./componente_lider/ver_staffs";
import PauseModal from "./componente_staff/PauseModal";
import RevisarActividadesSeniorGET from "./componente_senior_get/revisar_actividades_seniorget";
import RevisarActividadSolicitante from "./componente_solicitante/revisar_actividad_solicitante";
import PausedActivitiesSolicitante from "./componente_solicitante/solicitud_en_pausa";
import PausedActivitiesLider from "./componente_lider/PausedActivitiesLider";
import AsignacionesCompletadasStaff from "./componente_staff/asignaciones_completadas_staff";
import ActividadesFinalizadasStaff from "./componente_staff/asignaciones_finalizadas_staff";
import SolicitudesCreadasGET from "./componente_solicitante/enviadas_a_get";
import SolicitudesCanceladas from "./componente_solicitante/solicitudes_canceladas";
import SolicitudesCompletadasSenior from "./componente_solicitante/SolicitudesCompletadasSenior";
import SolicitudesCompletadasLider from "./componente_lider/actividades_completadas_lider";
import SolicitudesAnuladasLider from "./componente_lider/actividades_anuladas_lider";
import SolicitudesCompletadasSeniorGET from "./componente_senior_get/solicitudes_completadas_seniorget";
import IngresarMultiplesSolicitudes from "./componente_solicitante/ingresar_multiples_solicitudes";
import MenuSocioGET from "./componente_socio_get/menusocio_get";
import VerLiderSubrogante from "./componente_socio_get/ver_lider_subrogante";
import VerAsistentes from "./componente_socio_get/ver_asistentes";
import ActividadesCompletadasSocio from "./componente_socio_get/actividades_completadas_socio";
import ActividadGET from "./componente_socio_get/actividad_get";
import VerSeniorGET from "./componente_socio_get/ver_senior_get";
import VerLiderSubrogante2 from "./componente_senior_get/ver_lider_subrogante2";
import MenuSeniorGET from "./componente_senior_get/menu_senior";
import VerAsistente2 from "./componente_senior_get/ver_asistentes2";
import ActividadGET2 from "./componente_senior_get/actividad_get2";
import AsignacionesEnPausa from "./componente_staff/asignaciones_en_pausa";
import SolicitudesAnuladas from "./componente_socio_get/solicitudes_anuladas";
import SolicitudesAnuladas2 from "./componente_senior_get/solicitudes_anuladas2";
import VerUsuarios from "./componente_admin/usuarios";
import MenuAdmin from "./componente_admin/menu_Admin";
import Asistentes from "./componente_admin/asistentes";
import Lideres from "./componente_admin/lideres";
import Seniors from "./componente_admin/seniors";

function App() {
  return (
    <GrupoProvider>
      <ProjectProvider>
        <Router>
          <Routes>
            <Route
              path="/EnPausaSolicitante"
              element={<PausedActivitiesSolicitante />}
            />
            <Route
              path="/AsignacionesEnPausa"
              element={<AsignacionesEnPausa />}
            />
            <Route
              path="/SolicitudesCreadasGET"
              element={<SolicitudesCreadasGET />}
            />
            <Route
              path="/SolicitudesAnuladasLider"
              element={<SolicitudesAnuladasLider />}
            />
            <Route
              path="/SolicitudesCompletadasSeniorGET"
              element={<SolicitudesCompletadasSeniorGET />}
            />
            <Route
              path="/SolicitudesCanceladas"
              element={<SolicitudesCanceladas />}
            />
            <Route
              path="/SolicitudesCompletadasSenior"
              element={<SolicitudesCompletadasSenior />}
            />
            <Route path="/" element={<Login />} />
            <Route
              path="/SolicitudesCompletadasLider"
              element={<SolicitudesCompletadasLider />}
            />
            <Route path="/PausaLider" element={<PausedActivitiesLider />} />
            <Route
              path="/ActividadesFinalizadasStaff"
              element={<ActividadesFinalizadasStaff />}
            />
            <Route path="/sesion" element={<Sesion />} />
            <Route path="/menusolicitante" element={<MenuSolicitante />} />
            <Route
              path="/SolicitarServicioGET"
              element={<SolicitarServicioGET />}
            />
            <Route path="/IngresarSolicitud" element={<IngresarSolicitud />} />
            <Route path="/AsignarStaff" element={<AsignacionStaff />} />
            <Route path="/CuartaPagina" element={<CuartaPagina />} />
            <Route path="/PopupComponent" element={<PopupComponent />} />
            <Route path="/EsperaDocumentos" element={<EsperaDocumentos />} />
            <Route path="/menulider" element={<MenuLider />} />
            <Route
              path="/ActividadesSinDocumentar"
              element={<ActividadesSinDocumentar />}
            />
            <Route path="/menustaff" element={<MenuStaff />} />
            <Route path="/rol" element={<Rol />} />
            <Route path="/rol2" element={<Rol2 />} />
            <Route path="/rol3" element={<Rol3 />} />
            <Route
              path="/SolicitudesAsignadas"
              element={<SolicitudesAsignadas />}
            />
            <Route path="/MisAsignaciones" element={<MisAsignaciones />} />
            <Route path="/Cronometro" element={<Cronometro />} />
            <Route
              path="/AsignacionesEnRevision"
              element={<AsignacionesEnRevision />}
            />
            <Route
              path="/RevisarActividadLider"
              element={<RevisarActividadLider />}
            />
            <Route path="/VerStaff" element={<VerStaff />} />
            <Route path="/PauseModal" element={<PauseModal />} />
            <Route
              path="/RevisarActividadesSeniorGET"
              element={<RevisarActividadesSeniorGET />}
            />
            <Route
              path="/RevisarActividadSolicitante"
              element={<RevisarActividadSolicitante />}
            />
            <Route
              path="/Completadas_staff"
              element={<AsignacionesCompletadasStaff />}
            />
            <Route
              path="/IngresarMultiplesSolicitudes"
              element={<IngresarMultiplesSolicitudes />}
            />
            <Route path="/menusocio_get" element={<MenuSocioGET />} />
            <Route
              path="/VerLiderSubrogante"
              element={<VerLiderSubrogante />}
            />
            <Route path="/VerAsistentes" element={<VerAsistentes />} />
            <Route
              path="/ActividadesCompletadasSocio"
              element={<ActividadesCompletadasSocio />}
            />
            <Route path="/ActividadGET" element={<ActividadGET />} />
            <Route path="/VerSeniorGET" element={<VerSeniorGET />} />
            <Route
              path="/VerLiderSubrogante2"
              element={<VerLiderSubrogante2 />}
            />
            <Route path="/MenuSeniorGET" element={<MenuSeniorGET />} />
            <Route path="/VerAsistente2" element={<VerAsistente2 />} />
            <Route path="/ActividadGET2" element={<ActividadGET2 />} />
            <Route
              path="/SolicitudesAnuladas"
              element={<SolicitudesAnuladas />}
            />
            <Route
              path="/SolicitudesAnuladas2"
              element={<SolicitudesAnuladas2 />}
            />
            <Route path="/VerUsuarios" element={<VerUsuarios />} />
            <Route path="/MenuAdmin" element={<MenuAdmin />} />
            <Route path="/Asistentes" element={<Asistentes />} />
            <Route path="/Lideres" element={<Lideres />} />
            <Route path="/Seniors" element={<Seniors />} />
          </Routes>
        </Router>
      </ProjectProvider>
    </GrupoProvider>
  );
}

export default App;
